(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftArrow } from "../../icons/LeftArrow";
import Logo from "../Logo";
import styles from "./ErrorPlaceholder.module.css";

const ErrorPlaceholder = _ref => {
  let {
    desc,
    title1,
    title2,
    logoSrc,
    basicUrl
  } = _ref;
  const location = useLocation();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.page404
  }, logoSrc && /*#__PURE__*/React.createElement(Logo, {
    className: styles.logo,
    logoSrc: logoSrc,
    basicUrl: basicUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.circle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title1
  }, title1), /*#__PURE__*/React.createElement("div", {
    className: styles.title2
  }, title2), /*#__PURE__*/React.createElement("div", {
    className: styles.desc
  }, desc), /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: basicUrl || "/",
      search: location.search
    },
    className: styles.link
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.btn
  }, /*#__PURE__*/React.createElement(LeftArrow, {
    className: styles.icon,
    color: "rgba(51, 55, 65, 0.8)"
  }), t("Homepage"))))));
};

__signature__(ErrorPlaceholder, "useLocation{location}\nuseTranslation{{ t }}", () => [useLocation, useTranslation]);

ErrorPlaceholder.propTypes = {
  desc: PropTypes.node.isRequired,
  title1: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  logoSrc: PropTypes.string,
  basicUrl: PropTypes.string
};
ErrorPlaceholder.defaultProps = {
  logoSrc: null,
  basicUrl: null
};

const _default = /*#__PURE__*/React.memo(ErrorPlaceholder);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ErrorPlaceholder, "ErrorPlaceholder", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorPlaceholder/ErrorPlaceholder.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/ErrorPlaceholder/ErrorPlaceholder.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();